export type RoleStatusColor = 'warning' | 'success' | 'error' | 'default';

export const getRoleStatusInfo = (status: number | string): { statusText: string; statusColor: RoleStatusColor } => {
    if (typeof status === 'number') {
        switch (status) {
            case 0:
                return { statusText: 'pending', statusColor: 'warning' };
            case 1:
                return { statusText: 'approved', statusColor: 'success' };
            case 2:
                return { statusText: 'rejected', statusColor: 'error' };
            default:
                return { statusText: 'pending', statusColor: 'default' };
        }
    }

    switch (status?.toLowerCase()) {
        case 'pending':
            return { statusText: 'pending', statusColor: 'warning' };
        case 'approved':
            return { statusText: 'approved', statusColor: 'success' };
        case 'rejected':
            return { statusText: 'rejected', statusColor: 'error' };
        default:
            return { statusText: 'pending', statusColor: 'default' };
    }
};

export const isPendingRoleStatus = (status: number | string): boolean => {
    if (status === 0 || status === 'Pending') return true;
    return typeof status === 'string' && status.toLowerCase() === 'pending';
};

export const getPendingRequestRowClassName = (
    row: { approverUsernames?: string[]; assignedApproverUsername?: string | null },
    currentUsername: string
): string => {
    const approverUsernames = row.approverUsernames || [];
    const usernameLower = currentUsername?.toLowerCase();

    const isCurrentUserInApproverList =
        !!usernameLower &&
        approverUsernames.some((approver: string) => approver.toLowerCase() === usernameLower);

    const isAssignedApprover =
        !!usernameLower &&
        !!row.assignedApproverUsername &&
        usernameLower === row.assignedApproverUsername.toLowerCase();

    return isAssignedApprover || isCurrentUserInApproverList ? '' : 'warning-row';
};

export const getCurrentApproverUser = () => {
    try {
        const checkOperator = JSON.parse(localStorage.getItem('checkOperator') || '{}');
        return {
            userId: checkOperator?.applicationUserId || null,
            username: checkOperator?.username || '',
        };
    } catch {
        return {
            userId: null,
            username: '',
        };
    }
};
